import React from "react"

import * as Icons from "../assets/icons"
import { phone, email, hours, offices } from "../data/Contact"

const ContactDetails = () => (
  <div>
    <div className="contact-info-wrapper">
      <div className="contact-card">
        <div className="contact-card-icon">
          <Icons.Phone />
        </div>
        <h3>Telefon i e-mail</h3>
        <a href={phone.href} className="contact-card-main">
          {phone.display}
        </a>
        <a href={`mailto:${email}`}>{email}</a>
      </div>
      <div className="contact-card">
        <div className="contact-card-icon">
          <Icons.Location />
        </div>
        <h3>Nasze biura</h3>
        {offices.map((office) => (
          <address key={office.city} className="contact-card-address">
            <strong>{office.city}</strong>
            <span>{office.address}</span>
          </address>
        ))}
      </div>
      <div className="contact-card">
        <div className="contact-card-icon">
          <Icons.Clock />
        </div>
        <h3>Godziny otwarcia</h3>
        <table className="hours">
          <tbody>
            {hours.map(({ day, time }) => (
              <tr key={day} className={time ? "" : "closed"}>
                <td>{day}</td>
                <td>{time || "zamknięte"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    <div className="maps">
      {offices.map((office) => (
        <div key={office.city} className="map-card">
          <div className="map-card-header">
            <div>
              <h3>Biuro {office.city}</h3>
              {office.address && <p>{office.address}</p>}
            </div>
            <a
              href={office.url}
              target="_blank"
              rel="noopener noreferrer"
              className="button button-primary"
            >
              <Icons.Location /> Otwórz w Google Maps
            </a>
          </div>
          <iframe
            title={`Mapa dojazdu – biuro ${office.city}`}
            width="100%"
            height="400"
            frameBorder="0"
            loading="lazy"
            src={`https://maps.google.com/maps?q=${encodeURIComponent(`${office.name}, ${office.city}`)}&ll=${office.lat},${office.lng}&z=16&hl=pl&output=embed`}
          ></iframe>
        </div>
      ))}
    </div>
  </div>
)

export default ContactDetails
